export default function SwitchToggle({ checked, onChange }) {
    return (
        <label className="custom-switch">
            <input
                type="checkbox"
                checked={checked}
                onChange={onChange}
            />
            <span className="slider"></span>
        </label>
    );
}
